import { Button } from "reactstrap";
import Services from "./Services";

const JegyeladasFizetesButton = ({
  fizetesButtonLoading,
  bucket,
  event,
  init,
  rot,
  formNev,
  formFizetesiMod,
  formEmail,
  formBizonylatszam,
  formMegjegyzes,
  formVasarloiKartyaByAidOrSid,
  rendelesId,
  eszkozazonosito,
  CONSTANTS,
  setFizetesButtonLoading,
  addSuccess,
  goBack,
  getCompoundId,
}) => {
  function handlePayButtonClick(e) {
    e.target.blur();

    setFizetesButtonLoading(true);

    //álló jegyeket a virtualBucketből össze kell vonni, és a kedvezményeket 1 aid alá, List,be kell tenni, úgy kell küldeni backendre

    const merged = Object.values(
      bucket.filter(x => x.aid).reduce((acc, item) => {
        const key = getCompoundId(item.id, item.aid, item.tid, item.sid, item.ttid);
        // const key = getCompoundId(item.id);
        const kedvezmenyObj = item.kedvezmeny && item.kedvezmeny.id ? {
          tdd: formVasarloiKartyaByAidOrSid[getCompoundId(item.aid, item.sid, item.idx)] && formVasarloiKartyaByAidOrSid[getCompoundId(item.aid, item.sid, item.idx)].azonosito,
          tdi: item.kedvezmeny && item.kedvezmeny.id,
        } : null;
        if (!acc[key]) {
          acc[key] = { ...item };
          acc[key].qua = item.vqua ? parseInt(item.vqua, 10) : 0;
          if (kedvezmenyObj) {
            acc[key].tdi = [kedvezmenyObj];
          }
        } else {
          acc[key].qua += item.vqua ? parseInt(item.vqua, 10) : 0;
          if (kedvezmenyObj) {
            if (!acc[key].tdi){
              acc[key].tdi = [kedvezmenyObj];
            } else {
              acc[key].tdi.push(kedvezmenyObj)
            }
          }
        }
        return acc;
      }, {})
    );

    const areatickets = merged.map(item => ({
      rid: item.rid,
      id: item.id,
      aid: item.aid,
      tid: item.ttid,
      qua: item.qua,
      tdi: item.tdi,
    }));
    
    const seattickets = bucket.filter(x => x.sid).map((bucketItem, index) => ({
      rid: bucketItem.rid,
      id: bucketItem.id,
      sid: bucketItem.sid,
      tid: bucketItem.ttid,
      tdd: formVasarloiKartyaByAidOrSid[getCompoundId(bucketItem.aid, bucketItem.sid, index)] && formVasarloiKartyaByAidOrSid[getCompoundId(bucketItem.aid, bucketItem.sid, index)].azonosito,
      tdi: bucketItem.kedvezmeny && bucketItem.kedvezmeny.id,
    }));

    const adminPurchaseDto = {
      ste: 2,
      rid: event.rid,
      eid: event.eid,
      now: init.now,
      rot: rot.name,
      nam: formNev,
      pty: formFizetesiMod,
      ema: formEmail,
      rno: formBizonylatszam,
      not: formMegjegyzes,
      areatickets: areatickets,
      seattickets: seattickets,
      fizmodok: CONSTANTS.fizetesiModAzonositok,
    };

    const handlePdfLoaded = async (err, res) => {
      if (!err) {
        const blob = new Blob([res[0]], { type: "application/pdf" });
        const iframe = document.createElement("iframe");
        iframe.type = blob.type;
        iframe.src = URL.createObjectURL(blob);
        iframe.style.visibility = "hidden";

        document.body.appendChild(iframe);

        iframe.contentWindow.focus();
        iframe.contentWindow.print();

        window.setTimeout(() => window.close(), 2000);
        window.setTimeout(() => {
          goBack();
          document.body.classList.remove("sidebar-hidden");
        }, 7000);

        addSuccess("Jegy nyomtatás!");
      }
      setFizetesButtonLoading(false);
    };

    if (rendelesId) {
      Services.sendAdminPurchasePayPrint(adminPurchaseDto, true, eszkozazonosito, handlePdfLoaded);
    } else {
      Services.sendAdminPurchasePrint(adminPurchaseDto, true, eszkozazonosito, handlePdfLoaded);
    }
  }

  return (
    <Button
      style={{ marginBottom: 8, marginRight: 8 }}
      color="primary"
      type="button"
      disabled={fizetesButtonLoading}
      className="pull-right table-new-button"
      onClick={handlePayButtonClick}
    >
      Fizetés
    </Button>
  );
};

export default JegyeladasFizetesButton;
